var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-card"},[(_vm.isLoading)?_c('loading'):(!_vm.hasAuthorize.getById)?_c('no-auth'):(!_vm.cycle)?_c('not-found'):_c('div',[_c('PageTitle',{attrs:{"title":_vm.$t('cycle.copy', {
          serialNo: _vm.cycle.serialNumber,
        }),"description":_vm.$t('cycle.copyDescription')}}),_c('CycleForm',{attrs:{"cycle":_vm.cycle}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }